import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Users, ShieldCheck, KeyRound, Activity, Boxes, ShoppingBag, Receipt, LifeBuoy, Radio, KeySquare,
} from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data))
      .catch((e) => toast.error(e?.response?.data?.detail || "Failed to load stats"))
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    { k: "Total users", v: stats?.total_users, icon: Users },
    { k: "Active users", v: stats?.active_users, icon: Activity },
    { k: "Admins", v: stats?.admins, icon: ShieldCheck },
    { k: "Products", v: stats?.products, icon: ShoppingBag },
    { k: "Categories", v: stats?.categories, icon: Boxes },
    { k: "Orders paid", v: stats?.orders_paid, icon: Receipt },
    { k: "Orders pending", v: stats?.orders_pending, icon: Receipt },
    { k: "Open support", v: stats?.support_open, icon: LifeBuoy },
    { k: "Licenses active", v: stats?.licenses_active, icon: KeySquare },
    { k: "Signals subs", v: stats?.subscriptions_active, icon: Radio },
    { k: "API keys configured", v: stats?.api_keys_configured, icon: KeyRound },
  ];

  return (
    <div data-testid="admin-overview">
      <div className="mb-8">
        <p className="overline mb-2">Admin · Overview</p>
        <h1 className="font-editorial text-3xl font-medium tracking-tight text-white sm:text-4xl">
          Control room
        </h1>
        <p className="mt-2 max-w-xl text-sm text-emerald-100/60">
          Everything you need to run HK Forexedge from one green room.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {cards.map((c, i) => (
          <motion.div
            key={c.k}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04 }}
            className="card-edge p-5"
          >
            <div className="mb-4 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-300">
              <c.icon size={16} />
            </div>
            <p className="overline">{c.k}</p>
            <p className="mt-1 font-editorial text-3xl text-white">
              {loading ? "…" : (c.v ?? 0)}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
